(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-header"]) return;
  try {
    
  function preloadVideo() {
    const isNotMobile = window.matchMedia('(min-width: 1024px)').matches;
    if (!isNotMobile) return;

    const $videoItem = document.querySelector('.js-header-video');
    if (!$videoItem) return;

    const $videoSource = $videoItem.querySelector('source');
    if (!$videoSource) return;
    $videoSource.src = $videoSource.dataset.src;

    $videoItem.controls = false;
    $videoItem.load();
    $videoItem.play();
    $videoItem.style.opacity = '1';
  }

  function init() {
    preloadVideo();
  }

  document.addEventListener('DOMContentLoaded', init);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-members-filter"]) return;
  try {
    
  function collectiveMembersInit() {
    const $collectiveMembers = document.querySelector('.community-members');
    if (!$collectiveMembers ) return;

    const $grid = document.querySelector('.community-members-grid');
    if (!$grid ) return;

    const $items = $grid.querySelectorAll('.community-members-grid__item');
    if ($items.length === 0) return;

    const $filterItems = document.querySelectorAll('.community-members-filter__item');
    let isFiltering = false;

    function filterGrid (filter) {
      $items.forEach(($item) => {
        if (filter === 'all' || ['promo', filter].includes($item.dataset.type)) {
          $item.style.display = 'block';
        } else {
          $item.style.display = 'none';
        }
      });
    }

    function handleFilterChange (e) {
      if (isFiltering) return;

      isFiltering = true;
      const filter = e.target.dataset.filter;

      $filterItems.forEach(($item) => {
        if ($item !== e.target) {
          $item.classList.remove('community-members-filter__item--active');
        } else {
          $item.classList.add('community-members-filter__item--active');
        }
      });

      $grid.classList.add('hidden');
      setTimeout(() => filterGrid(filter), 300);
      setTimeout(() => {
        $grid.classList.remove('hidden');
        isFiltering = false;
      }, 350);
    }

    $filterItems.forEach(($item) => {
      $item.addEventListener('click', handleFilterChange);
    });
  }

  function init() {
    collectiveMembersInit();
  }

  document.addEventListener('DOMContentLoaded', init);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-members-grid"]) return;
  try {
    
  function preloadVideoHovers() {
    const $allMembersWithVideo = document.querySelectorAll('.js-member');

    $allMembersWithVideo.forEach($memberWithVideo => {
      const $videoItem = $memberWithVideo.querySelector('.js-member-video');
      if (!$videoItem) return;

      const $videoSource = $videoItem.querySelector('source');
      if (!$videoSource) return;
      $videoSource.src = $videoSource.dataset.src;
      $videoItem.load();

      $memberWithVideo.addEventListener('mouseover', () => {
        $videoItem.style.opacity = '1';

        try {
          $videoItem.play();
        } catch(error) {
          // do nothing
        }
      });
      $memberWithVideo.addEventListener('mouseout', () => {
        $videoItem.style.opacity = '0';
        $videoItem.pause();
        $videoItem.currentTime = 0;
      });
    });
  }

  function moveSecondGridItemsToFirstGrid() {
    const $grids = [...document.querySelectorAll('.community-members-grid')];
    const $firstGrid = $grids[0];
    const $secondGrid = $grids[1];
    if (!$firstGrid || !$secondGrid) return;

    const $items = $secondGrid.querySelectorAll('.community-members-grid__item');

    $items.forEach(function($item) {
      $firstGrid.appendChild($item);
    });

    $secondGrid.remove();
  }

  function formatEmptyLinks() {
    const $links = [...document.querySelectorAll('.community-members-grid__image-wrapper')];
    $links.forEach($link => {
      if (!$link.getAttribute('href')) {
        $link.style.cursor = 'default';
        $link.setAttribute('href', '#');
        $link.addEventListener('click', event => {
          event.preventDefault();
        }
      )}
    });
  }

  function init() {
    preloadVideoHovers();
    moveSecondGridItemsToFirstGrid();
    formatEmptyLinks();
  }

  document.addEventListener('DOMContentLoaded', init);

  } catch(e) { console.error(e); }
})();
})();
